<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Razdoblja</h5><br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                    v-if="show_datatable"
                    :url="datatables_url"
                    :settings="datatables.settings"
                    :title="datatables.title"
                    @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>
</template>

<script>
import Datatables from "../../../../components/datatable/Datatables";
import OsobeNavigation from "../OsobeNavigation";
export default {
    name: "OsobaGrupaStatusa",
    components: { OsobeNavigation, Datatables },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'osoba-razdoblje',
            datatables: {},
            breadcrumbs: [],
            osoba_id: this.$route.params.osoba_id
        }
    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/osobe/' + this.osoba_id + '/razdoblja/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/osobe/' + this.osoba_id + '/razdoblja/create' } )
        },

        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'osoba_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.osoba_id
                            },
                        },
                        {
                            'id': 'datum_od',
                            'title': 'Od',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'osoba-razdoblje',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'datum_do',
                            'title': 'Do',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'osoba-razdoblje',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'sati',
                            'title': 'Sati',
                            'type' : function( row ){
                                return row.sati
                            },
                            'column_visibility_group': {
                                'id': 'osoba-razdoblje',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'sati_regulativa',
                            'title': 'Sati regulativa',
                            'type' : function( row ){
                                return row.sati_regulativa
                            },
                            'column_visibility_group': {
                                'id': 'osoba-razdoblje',
                                'visible' : true
                            }
                        },



                    ],
                    column_visibility_groups:{
                        'osoba-razdoblje' : 'Razdoblja'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Razdoblja',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/razdoblje',
                    name: 'Razdoblja'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>
